import React, {Component} from 'react';
import CallsList from './CallsList';
import {closeAlert} from "../../../actions/commonsActions";
import {fetchCalls, updateSingleCall} from "../../../actions/callsActions";
import {CALLS_TYPES, USER_ROLES} from "../../../helpers/constants";
import {connect} from "react-redux";
import {Alert, Card, CardBody, CardTitle} from "reactstrap";
import {fetchBasicOfferPrefs} from "../../../actions/promoActions";
import swal from "sweetalert";
import ReactDOM from 'react-dom';
import Spinner from "./Spinner";

class Calls extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 0,
            filters: [],
            companyId: '',
            sortState: {
                id: 'name',
                desc: true
            },
            sorting: false,
        };
    }

    componentDidMount() {
        (async () => {
            await this.props.fetchCalls({
                page: 0,
                retailerCompanyId: this.props.company.id
            });
            this.props.fetchBasicOfferPrefs();
        })();
    }

    fetchPaginatedData = async currentPage => {
        await this.props.fetchCalls({
            filters: this.state.filters.length ? this.state.filters : false,
            sorting: this.state.sorting ? this.state.sorting : false,
            page: currentPage,
            retailerCompanyId: this.props.company.id
        });
        await this.setState({
            currentPage,
            sortState: this.state.sorting ? this.state.sorting : {
                id: 'name',
                desc: true
            }
        });
    };

    acceptCall = async data => {
        let wrapper = document.createElement('div');
        ReactDOM.render(<Spinner/>, wrapper);
        let spinner = wrapper.firstChild;
        await swal({
            title: 'Введите процент выплаты сотруднику',
            icon: "warning",
            buttons: ['Отменить', 'Принять предложение'],
            content: spinner,
        }).then(async (percent) => {
            if (percent) {
                if (typeof percent === 'boolean') {
                    percent = 0;
                }
                return await this.props.updateSingleCall({
                    id: data.id,
                    status: data.status,
                    employeeRewardPercent: percent,
                }).then(response => {
                    if (response.status !== '200') {
                        throw new Error(response.statusText)
                    }
                }).catch(() => {
                    swal(
                        `Что-то пошло не так`,
                        "",
                        "error")
                })
            }
        });
        this.fetchPaginatedData(0)
    }

    updateCall = async data => {
        if (data.status === CALLS_TYPES.ACCEPTED) {
            await this.acceptCall(data);
        } else {
            await this.props.updateSingleCall({
                id: data.id,
                status: data.status,
                employeeRewardPercent: data.employeeRewardPercent
            })
            this.fetchPaginatedData(0)
        }
    };


    render() {
        const {lang, loading} = this.props;
        const callsList = loading ? <div className="loading">Loading...</div> :
            <CallsList
                calls={this.props.calls}
                currentPage={this.state.currentPage}
                updateCall={this.updateCall}
                basicOfferPrefs={this.props.basicOfferPrefs}
                lang={lang}
            />
        return (
          <div className="calls">
              <Alert
                  color={`${this.props.alert.alert.status}`}
                  isOpen={this.props.alert.isOpen || false}
              >
                  {this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed": ''}
              </Alert>
              <Card>
                  <CardTitle className="mb-0 p-3 border-bottom bg-light">
                      <div>
                          <i className="mdi mdi-border-right mr-2"></i>Офферы
                      </div>
                      {/*<Button color="primary" type="button" onClick={this.addAttributeClick}>Добавить атрибут</Button>*/}
                  </CardTitle>
                  <CardBody>
                      {callsList}
                  </CardBody>
              </Card>
          </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchCalls: query => dispatch(fetchCalls(query)),
        fetchBasicOfferPrefs: () => dispatch(fetchBasicOfferPrefs()),
        updateSingleCall: query => dispatch(updateSingleCall(query)),
        closeAlert: () => dispatch(closeAlert())
    };
};

const mapStateToProps = state => ({
    alert: state.alert,
    calls: state.calls.calls,
    pagination: state.calls.pagination,
    loading: state.calls.loading,
    basicOfferPrefs: state.basicOfferPrefsList.prefs,
    company: state.companiesReducer.companies.length > 1 ? {id: 1} : state.companiesReducer.companies[0],
    authority:  state.currentUser.roles[0].authority || USER_ROLES.GUEST,
    lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(Calls)




// WEBPACK FOOTER //
// ./src/components/Promo/Calls/Calls.js